import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (email) {
      fetch(
        `https://impactstoriesfund.org/api/unsubscribe?email=${encodeURIComponent(
          email
        )}`
      )
        .then((response) => response.json())
        .then((data) => {
          setStatus(data.status); // Laravel should return status: "success" or "notfound"
        })
        .catch(() => {
          setStatus("error");
        });
    } else {
      setStatus("invalid");
    }
  }, [email]);

  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      {status === "loading" ? (
        <h2>Processing your request...</h2>
      ) : status === "success" ? (
        <h2>We're sad to see you go! 😢</h2>
      ) : status === "notfound" ? (
        <h2>Email not found or already unsubscribed. 🤷‍♂️</h2>
      ) : status === "error" ? (
        <h2>Something went wrong. Please try again later. ⚠️</h2>
      ) : (
        <h2>Invalid request. Please try again. 🚫</h2>
      )}
      <p>
        Thank you for being part of Impact Stories Fund. You can resubscribe
        anytime.
      </p>
      <a
        href="https://impactstoriesfund.org"
        style={{ color: "blue", textDecoration: "underline" }}
      >
        Return to Homepage
      </a>
    </div>
  );
};

export default Unsubscribe;
